import { PartialType } from '@nestjs/swagger';
import { CreateSolicitudCreditoDto } from './create-solicitud-credito.dto';

export class UpdateSolicitudCreditoDto extends PartialType(CreateSolicitudCreditoDto) {}
